import type { FaireProductEntity } from "../../entity_types/product";

export const p_5a3vgqu69m: FaireProductEntity = {
  token: "p_5a3vgqu69m",
  type: "product",
  name: "Vanilla Donuts 8-Pack (VE, GF, K, No Sugar, Soy-Free)",
  brandToken: "b_d3ssphc04o",
  brandName: "Planet Bake",
  imageUrl:
    "https://cdn.faire.com/fastly/1f6a8b2e54bfa291d4c91c711770715d174b21764ea273dd6386325b3d1e5673.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/50734c34983b44a50b14722bc0f8af477480d4a47d069ac27c12313d3fab1d3d.png",
    "https://cdn.faire.com/fastly/11f8dda61dcccc1f9e1233770d160fde0e0a12801c912bf580301432cad081e0.png",
    "https://cdn.faire.com/fastly/f9d185826e37b74bb88b21e13f561793ed9f37ca6215e8578c63d9cde83f0715.png",
    "https://cdn.faire.com/fastly/8e2af4b86e3d73207c8fc663308f2ca938f0cd42822e30702f9b31e6a7fc4b18.png",
    "https://cdn.faire.com/fastly/b4154ce08dd6442bb4d9914f28af9a06f82bbe8fe222d91f264225b1f08aca9b.png",
    "https://cdn.faire.com/fastly/53150cf209b5c8e3fd48b18412b2ae72fd2af312bb46de81043a476a2bcf9374.png",
    "https://cdn.faire.com/fastly/9d375c54cf9cd698d356a1ac484967ba2be89e8b7fc05af8488842d8947b4224.png",
  ],
  priceDollars: 32.7,
  description:
    "Benefits?\n\n\n✓ VEGAN ✓ GLUTEN FREE ✓ SUGAR FREE ✓ LOW NET CARB ✓ NON GMO ✓ KOSHER ✓ HIGH FIBER ✓ SOY-FREE ✓ CLEAN INGREDIENTS\n\n\n\n\n\n\nIndulge in pure decadence with our Frosted Vanilla Bean Donuts, meticulously crafted to captivate your senses with every bite. Made with the finest vanilla beans, each donut is a symphony of rich, aromatic flavor and velvety texture. Topped with a luscious vanilla bean frosting, these treats offer a perfect balance of sweetness and sophistication. Whether enjoyed as a morning pick-me-up or a delightful dessert, our Frosted Vanilla Bean Donuts are sure to elevate any moment into a blissful indulgence. Treat yourself to the luxury of pure vanilla perfection and experience the unparalleled pleasure of our exquisite donuts.\n\n*Nutrition Information can be found in the images!\n\n\nAllergens?\n\n\nContains Tree Nuts.\n\nShelf Life - Room Temperature 3 months | Refrigerated 6 months | Frozen 12 months.\n\n*See packaging for more information!\n\n\n\n\n",
  tags: [],
  msrpDollars: 65.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:18.152Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
